import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    class: "inline-flex",
    role: "group"
};
import '../calcolatriceMedica.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseButtons',
    props: {
        hiddenCancellaButton: Boolean,
        hiddenCalcolaButton: Boolean,
        hiddenSalvaButton: Boolean,
    },
    emits: ["clearForm", "calculate", "saveResult"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('clearForm')); }),
                    class: "btnBase"
                }, _toDisplayString(_ctx.$t('Cancella')), 513), [
                    [_vShow, !__props.hiddenCancellaButton]
                ]),
                _withDirectives(_createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('calculate')); }),
                    class: "btnBase"
                }, _toDisplayString(_ctx.$t('Calcola')), 513), [
                    [_vShow, !__props.hiddenCalcolaButton]
                ]),
                _withDirectives(_createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.$emit('saveResult')); }),
                    class: "btnBase"
                }, _toDisplayString(_ctx.$t('Salva Punteggio')), 513), [
                    [_vShow, !__props.hiddenSalvaButton]
                ])
            ]));
        };
    }
});
